import styles from "./onboardingLayout.module.css";

/**
 * Unified onboarding layout with:
 * - Header: back arrow + business name
 * - Step progress: 3 bars
 * - Content area
 *
 * stepGroup: 0 = lines hidden (register), 1 = first bar, 2 = second bar, 3 = third bar (success)
 */
const OnboardingLayout = ({ children, stepGroup = 0, onBack, showSteps = true }) => {
  const businessName = localStorage.getItem("ownerName") || "";

  return (
    <div className={styles.layout}>
      {/* Header — hide on first step (no back, no name yet) */}
      {(onBack || (businessName && stepGroup > 0)) && (
        <div className={styles.header}>
          {onBack ? (
            <button className={styles.backBtn} onClick={onBack}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M9 18l6-6-6-6" />
              </svg>
            </button>
          ) : <div className={styles.backPlaceholder} />}
          <span className={styles.businessName}>{businessName}</span>
          <div className={styles.backPlaceholder} />
        </div>
      )}

      {/* Step Progress — 3 bars */}
      {showSteps && stepGroup > 0 && (
        <div className={styles.stepsWrap}>
          <div className={`${styles.stepBar} ${stepGroup >= 1 ? styles.stepActive : ""}`} />
          <div className={`${styles.stepBar} ${stepGroup >= 2 ? styles.stepActive : ""}`} />
          <div className={`${styles.stepBar} ${stepGroup >= 3 ? styles.stepActive : ""}`} />
        </div>
      )}

      {/* Content */}
      <div className={styles.content}>
        {children}
      </div>
    </div>
  );
};

export default OnboardingLayout;
